var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeachingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0495 12.7004L21.2328 16.1837C20.5328 19.1921 19.1495 20.4087 16.5495 20.1587C16.1328 20.1254 15.6828 20.0504 15.1995 19.9337L13.7995 19.6004C10.3245 18.7754 9.2495 17.0587 10.0662 13.5754L10.8828 10.0837C11.0495 9.37541 11.2495 8.75875 11.4995 8.25041C12.4745 6.23375 14.1328 5.69208 16.9162 6.35041L18.3078 6.67541C21.7995 7.49208 22.8662 9.21708 22.0495 12.7004Z",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.5493 20.1583C16.0326 20.5083 15.3826 20.8 14.591 21.0583L13.2743 21.4917C9.96597 22.5583 8.22431 21.6667 7.14931 18.3583L6.08264 15.0667C5.01597 11.7583 5.89931 10.0083 9.20764 8.94167L10.5243 8.50833C10.866 8.4 11.191 8.30833 11.4993 8.25C11.2493 8.75833 11.0493 9.375 10.8826 10.0833L10.066 13.575C9.24931 17.0583 10.3243 18.775 13.7993 19.6L15.1993 19.9333C15.6826 20.05 16.1326 20.125 16.5493 20.1583Z",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.5332 11.1084L18.5749 12.1334",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7168 14.333L16.1335 14.9497",
    stroke: "#5F6060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#5F6060",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachingIcon);
export default __webpack_public_path__ + "static/media/teaching-icon.cc045875da84031516e25f92b05e6c0b.svg";
export { ForwardRef as ReactComponent };